export default __webpack_public_path__ + "static/photo-10-610114f46e7b49d61e92825a87b21a8f.jpg";